import React, { useState, useEffect, useRef } from 'react';

function TextField(props) {

  const { label, name, id, fieldId, isRequired, errId, caseId, divClass, value, caseCheckId, drugIndex, checkDetailsIndex, fieldName,customError=false, isDisabled, index, collegeOther, labelStyle, nomineeIndex, nomineeFieldIdx } = props;

  console.log(value , name);

  //Handling Initial States Floating Labels
  const [formData, setFormData] = useState({
    [name]: null,
  });

  useEffect(() => {

    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    if(fieldId == 'university_board_other' ){
      let element = document.getElementById(id)
      element.parentElement.children[1].classList.add('focused');
    }   

  }, [value]);

  //Handling Floating Labels
  const handleFloatingLabels = (e) => {

    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));

    props.inputText([{ "name": name, "value": e.target.value, "fieldId": fieldId, "isRequired": isRequired, "drugIndex": drugIndex, "err_id": errId, "caseId": caseId, "caseCheckId": caseCheckId, "checkdetailsindex": checkDetailsIndex, "fieldname": fieldName, "index": index, 'collegeOther' : collegeOther , 'nomineeFieldIdx' : nomineeFieldIdx, 'nomineeIndex' : nomineeIndex, 'id' : id }]);


   
  }


  // const handleChange = (selectedOption) => {

  //   props.inputText({ "name": name, "value": selectedOption.value, "fieldId": fieldId, "isRequired": isRequired, "err_id": `err-${fieldId}` });
 
  //   //setKeyword(selectedOption.name);

  // };

  let elementClass = 'col-sm-4 col-md-12 col-xl-4';
  if(divClass){
    elementClass = divClass;
  }

  return (
    <> 
      <div className={elementClass}>
        <div className="form-group">
        <div className={`floating-label has-left-icon ${label.length > 20 ? 'small' : ''}`} 
        style={{fontSize: `${label.length > 25 ? 'small' : 'medium'}`, textOverflow: 'ellipsis'}}
        >
            <input type="text" className="form-control" name={name} id={id} drugIndex={drugIndex}  data-checkdetailsindex={checkDetailsIndex} onChange={handleFloatingLabels} autoComplete="off" value={formData[name]} disabled={isDisabled}/>
            <label htmlFor={props.id ? props.id : ''} className={formData[name] && 'focused'} style={labelStyle}>{label}{isRequired == 1 && <sup className="text-danger">*</sup>}</label>
          </div>
          <p className="err text-danger" id={errId}></p> 
        </div>
      </div>
    </>
  );
}

export default TextField;
